/**
 * Format Text
 * Automatically superscripts trademark symbols (®, ™) in text content.
 */
(function () {
  function formatTrademarkSymbols() {
    const walker = document.createTreeWalker(
      document.body,
      NodeFilter.SHOW_TEXT,
      {
        acceptNode: function (node) {
          const parent = node.parentNode;
          if (parent.tagName === 'SCRIPT' || parent.tagName === 'STYLE' || parent.tagName === 'SUP') {
            return NodeFilter.FILTER_REJECT;
          }
          if (/[®™]/.test(node.nodeValue)) {
            return NodeFilter.FILTER_ACCEPT;
          }
          return NodeFilter.FILTER_REJECT;
        }
      }
    );

    const textNodes = [];
    while (walker.nextNode()) {
      textNodes.push(walker.currentNode);
    }

    textNodes.forEach((node) => {
      const parts = node.nodeValue.split(/([®™])/);
      if (parts.length === 1) return;

      const fragment = document.createDocumentFragment();

      parts.forEach((part) => {
        if (part === '®' || part === '™') {
          const sup = document.createElement('sup');
          sup.textContent = part;
          fragment.appendChild(sup);
        } else if (part) {
          fragment.appendChild(document.createTextNode(part));
        }
      });

      node.parentNode.replaceChild(fragment, node);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', formatTrademarkSymbols);
  } else {
    formatTrademarkSymbols();
  }
})();
